import store from '@polleverywhere/redux'
import { platform } from '@polleverywhere/slideware-bindings'
import { slice as appSlice } from '../slices/app'
import isMobileApp from './is_mobile_app'

export function userSource () {
  const { role } = store.getState()[appSlice.name]
  if (role === 'slideware') {
    const p = platform()
    if (p === 'google') return 'goog_presenter_login'
    if (p === 'windows') return 'win_presenter_login'
    if (p === 'mac') return 'mac_presenter_login'
  }
  if (role === 'participant') {
    if (isMobileApp()) return 'mobile_app_login'
    return 'mobile_web_login'
  }
  if (role === 'agave') return 'agave_presenter_login'
  if (role === 'webex') return 'webex'
  return 'signup_api'
}
